// ------------------------------------------------
// Helper Functions
// ------------------------------------------------

// ===------ Make foreach functions play nice with query selector all ------===
const forEachAll = function (array, callback, scope) {
  for (var i = 0; i < array.length; i++) {
    callback.call(scope, i, array[i]); // passes back stuff we need
  }
};

// ===------ A simeple check to see if element exists ------===
const doIexist = function (element, callback) {
  if (document.querySelector(element)) {
    callback();
  }
};

// ===------ checks if element has a class ------===
function hasClass(element, cls) {
  return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
}

// ===------ Event on keydown ------===
const onReturn = function (element, callback) {
  element.addEventListener('keydown', function (e) {
    callback(e);
  });
};

// ===------ Event on click ------===
const clickEvt = (element, callback) => {
  element.addEventListener('click', function (e) {
    callback(e);
  });
};

// ===------ Remove all class ------===
const toggleClasses = function (mode = 'add', elementArry, classToRemove) {
  if (mode === 'add') {
    forEachAll(elementArry, function (index) {
      elementArry[index].classList.add(classToRemove);
    });
  } else if (mode === 'remove') {
    forEachAll(elementArry, function (index) {
      elementArry[index].classList.remove(classToRemove);
    });
  } else if (mode === 'toggle') {
    forEachAll(elementArry, function (index) {
      elementArry[index].classList.toggle(classToRemove);
    });
  }
};

// ===------ Scroll Watcher ------===
const scrollWatch = (element, classtoggle, watchdirection, windowdistance) => {
  window.addEventListener('scroll', () => {
    let elpos;
    if (watchdirection === 'bottom') {
      elpos = element.getBoundingClientRect().bottom;
    } else {
      elpos = element.getBoundingClientRect().top;
    }

    if (elpos <= windowdistance) {
      element.classList.add(classtoggle);
    } else {
      element.classList.remove(classtoggle);
    }
  });
};

// ===------ IE 10 fix for window location origin ------===
if (!window.location.origin) {
  window.location.origin =
    window.location.protocol +
    '//' +
    window.location.hostname +
    (window.location.port ? ':' + window.location.port : '');
}

// ===------ remove item from array based on value ------===
Array.prototype.remove = function () {
  var what,
    a = arguments,
    L = a.length,
    ax;
  while (L && this.length) {
    what = a[--L];
    while ((ax = this.indexOf(what)) !== -1) {
      this.splice(ax, 1);
    }
  }
  return this;
};

// ====---------------====
// Sticky Side nav
// ====---------------====
// window.onload = () => {
//   if (document.querySelector('[data-sticky="top"]')) {
//     const sitckyItems = document.querySelectorAll('[data-sticky="top"]');

//     forEachAll(sitckyItems, index => {
//       scrollWatch(sitckyItems[index], 'js-fixed', 'top', 0);
//     });
//   }

//   if (document.querySelector('.site-footer')) {
//     window.addEventListener('scroll', () => {
//       const sfPos = document
//           .querySelector('.site-footer')
//           .getBoundingClientRect().bottom,
//         winPos = window.outerHeight,
//         _sideNav = document.querySelector('.side-nav');

//       if (sfPos <= winPos) {
//         _sideNav.classList.add('js-footer-showing');
//       } else {
//         _sideNav.classList.remove('js-footer-showing');
//       }
//     });
//   }
// };

// ====---------------====
// Bootstrap Stuff
// ====---------------====
jQuery(document).ready(function ($) {
  $('[data-toggle="popover"]').popover({
    html: true,
  });

  $('[data-toggle="tooltip"]').tooltip({
    html: true,
  });
});

// ------------------------------------------------
// Header Toggles
// ------------------------------------------------
// Opens and closes sections of the header
const toggleHeader = {
  openTriggers: document.querySelectorAll('[data-toggle-class]'),
  closeTriggers: document.querySelectorAll('[data-toggle-close]'),
  openClasses: ['js-sm-open', 'js-search-open', 'js-sign-open'],
  settings: {
    speedClose: 200,
    speedOpen: 500,
  },
  open: function (_element) {
    const tclass = _element.getAttribute('data-toggle-class'),
      elAriaId = _element.getAttribute('data-aria-id'),
      elAriaTitle = _element.getAttribute('data-aria-title'),
      _body = document.querySelector('body'),
      openClasses = this.openClasses;

    let coState = false;
    let _closeEl;

    forEachAll(openClasses, function (index) {
      if (hasClass(_body, openClasses[index]) && openClasses[index] != tclass) {
        coState = true;
        _closeEl = document.querySelector(
          '[data-toggle-class=' + openClasses[index] + ']'
        );
      }
    });

    const openMain = function () {
      // isn't open add open class
      _body.classList.add(tclass);

      // add aria-expanded
      _element.setAttribute('aria-expanded', true);

      // Add aria mesage to region
      document.querySelector('#' + elAriaId).innerHTML =
        elAriaTitle + ' opened. Navigate to the content below.';

      if (tclass === 'js-sm-open') {
        document.querySelector('.sm__menu').setAttribute('aria-expanded', true);
      } else {
        _element.nextElementSibling.setAttribute('aria-expanded', true);
      }

      // add animate class then clear post animation
      _body.classList.add('js-animate-in');
      setTimeout(() => {
        _body.classList.remove('js-animate-in');

        if (hasClass(_body, 'js-search-open')) {
          document.getElementById('siteSearchInput').focus();
        } else if (hasClass(_body, 'js-sign-open')) {
          document.getElementById('loginUser').focus();
        }
      }, toggleHeader.settings.speedClose);
    };

    // Checking if already open or not
    if (!hasClass(_body, tclass)) {
      if (coState) {
        this.close(_closeEl);

        setTimeout(() => {
          openMain();
        }, toggleHeader.settings.speedClose);
      } else {
        openMain();
      }
    } else {
      this.close(_element);
    }
  },
  close: function (_element) {
    const tclass = _element.getAttribute('data-toggle-class'),
      elAriaId = _element.getAttribute('data-aria-id'),
      elAriaTitle = _element.getAttribute('data-aria-title'),
      _body = document.querySelector('body');

    if (hasClass(_body, tclass)) {
      // aria-expanded to false
      _element.setAttribute('aria-expanded', false);

      // Add aria message to region
      document.querySelector('#' + elAriaId).innerHTML =
        elAriaTitle + ' closed.';

      if (tclass === 'js-sm-open') {
        document
          .querySelector('.sm__menu')
          .setAttribute('aria-expanded', false);
      } else {
        _element.nextElementSibling.setAttribute('aria-expanded', false);
      }

      // add animate class then clear post animation
      _body.classList.add('js-animate-out');
      setTimeout(() => {
        _body.classList.remove(tclass);
        _body.classList.remove('js-animate-out');
      }, toggleHeader.settings.speedClose);
    }
  },
  bindOpen: function () {
    forEachAll(toggleHeader.openTriggers, function (index) {
      toggleHeader.openTriggers[index].addEventListener('click', function () {
        toggleHeader.open(this);
      });
    });
  },
  bindClose: function () {
    forEachAll(toggleHeader.closeTriggers, function (index) {
      toggleHeader.closeTriggers[index].addEventListener('click', function () {
        const _body = document.querySelector('body');
        let bcOpens = toggleHeader.openClasses;

        forEachAll(bcOpens, function (index) {
          if (hasClass(_body, bcOpens[index])) {
            let bcButton = document.querySelector(
              '[data-toggle-class=' + bcOpens[index] + ']'
            );

            _body.classList.remove(bcOpens[index]);
            bcButton.setAttribute('aria-expanded', false);
            if (bcOpens[index] === 'js-sm-open') {
              document
                .querySelector('.sm__menu')
                .setAttribute('aria-expanded', false);
            } else {
              bcButton.nextElementSibling.setAttribute('aria-expanded', false);
            }
          }
        });
      });
    });
  },
  escClose: function () {
    window.addEventListener('keydown', function (event) {
      if (event.keyCode === 27) {
        let openItem = document.querySelector(
          '[data-toggle-class][aria-expanded="true"]'
        );
        toggleHeader.close(openItem);
      }
    });
  },
  gogo: function () {
    toggleHeader.bindClose();
    toggleHeader.bindOpen();
    toggleHeader.escClose();
  },
};
toggleHeader.gogo();

// ====---------------====
// Post sorting
// ====---------------====
if (document.querySelector('#sortPostsForm')) {
  const pageurl = window.location.pathname;

  const getsortvalue = function () {
    const button = document.querySelector('#sortPostsForm .btn');
    button.addEventListener('click', function (e) {
      let curval = document.querySelector('#sortPosts').value;
      window.location.replace(pageurl + curval);
    });
  };

  getsortvalue();
}

// ------------------------------------------------
// Grid tabs
// ------------------------------------------------

if (document.querySelector('.grid-tabs')) {
  let tabNav = document.querySelectorAll('.grid-tab-nav'),
    tabContent = '',
    gridWrapper = document.querySelector('.grid-tab-nav-wrapper ul');

  forEachAll(tabNav, function (index) {
    tabNav[index].addEventListener('click', function (e) {
      e.preventDefault();

      //checking for window size
      if (window.innerWidth <= 767) {
        //if the window size is tablet / smaller its going to check the grid-wrapper for the following class and remove it if it has it on each of the tab navs
        if (gridWrapper.classList.contains('js-open')) {
          gridWrapper.classList.remove('js-open');

          forEachAll(tabNav, function (x) {
            tabNav[x].classList.remove('js-open');
          });
        } else {
          //going to add the js-open class
          gridWrapper.classList.add('js-open');
          //after the class is added going to move the active select to the top of the list
          gridWrapper.insertBefore(e.target, gridWrapper.firstChild);

          forEachAll(tabNav, function (z) {
            tabNav[z].classList.add('js-open');
          });
        }
      }

      if (!tabNav[index].classList.contains('active')) {
        forEachAll(tabNav, function (i) {
          if (tabNav[i].classList.contains('active')) {
            tabNav[i].classList.remove('active');
            tabContent = document.getElementById(
              tabNav[i].getAttribute('data-tab')
            );
            toggleClasses('remove', [tabContent], 'active');
          }
        });
        tabNav[index].classList.add('active');
        tabContent = document.getElementById(
          tabNav[index].getAttribute('data-tab')
        );
        toggleClasses('add', [tabContent], 'active');
      }
    });
  });
}

function maintainFocus(elements) {
  elements.forEach((element) => {
    const el = document.querySelector(element),
      focusableElements = 'button, input, [href], [tabindex]:not([tabindex="-1"])',
      firstFocusableElement = el.querySelectorAll(focusableElements)[0], 
      // get first element to be focused inside element
      focusableContent = el.querySelectorAll(focusableElements),
      lastFocusableElement = focusableContent[focusableContent.length - 1]; 
      // get last element to be focused inside element
    document.addEventListener('keyup', function (e) {
      let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
      if (!isTabPressed) {
        return;
      }
      if (e.shiftKey) {
        // if shift key pressed for shift + tab combination
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus(); // add focus for the last focusable element
          e.preventDefault();
        }
      } else {
        // if tab key is pressed
        if (document.activeElement === lastFocusableElement) {
          // if focused has reached to last focusable element then focus first focusable element after pressing tab
          firstFocusableElement.focus(); // add focus for the first focusable element
          e.preventDefault();
        }
      }
    });
    firstFocusableElement.focus();
  });
}

maintainFocus(['.featured-nav','.site-search'])